import { Employee } from './employees';

export const EMPLOYEES: Employee[] = [
    {
        id: 1,
        name: 'Ralf Roeber',
        position: 'Managing Partner',
        about: ['+25 years of experience in IT industry', 'In depth knowledge of OSI level 2 to 7', 'Internet standards expert', '+20 years IBM Cognos professional', 'IBM performance star (2006)', 'IBM Champion 2021-2025'],
        gender: 'M',
        profilePicture: '00_AMVARA_Staff_Ralf_BN.jpg'
    },
    {
        id: 2,
        name: 'Luz Maria Leon',
        position: 'Business Development',
        about: ['Business Consultant'],
        gender: 'F',
        profilePicture: '00_AMVARA_Staff_LUZMA_BN.jpg'
    },
    {
        id: 3,
        name: 'Nagesh Narasappa',
        position: 'Full Stack & Service Management',
        about: ['+13 year of experience in IT industry',  
        'PMP Certified (2024)',
        'Service Management',
        'Infrastructure consulting',
        'Operations Management'],
        gender: 'M',
        profilePicture: '00_AMVARA_Staff_nagesh_BN.jpg'
    },
    {
        id: 4,
        name: 'Anand Kushwaha',
        position: 'Backend Developer',
        about: ['Full Stack developer | Kubernetes | Cometa ', 
        'Expertise in Python, Django, Java, Angular, Nodejs',
        'DevOps Enthusiast, CICD, Docker, Kubernetes, AWS',
        'Linux Server Administration – managing 10+ servers efficiently',
        'Open Source Contributor'
        ],
        gender: 'M',
        profilePicture: '00_AMVARA_Staff_Anand_BN.png'
        
    },
    {
        id: 5,
        name: 'Nico Clariana',
        position: 'Full Stack Developer',
        about: ['Experience in Java and C++ Development'],
        gender: 'M',
        profilePicture: 'avatar_anonim.png'
    },
    {
        id: 6,
        name: 'Yoel Berjaga',
        position: 'Full Stack & Service Management',
        about: ['End-to-end IT delivery - full stack development and service management', 'Whatever the project needs'],
        gender: 'M',
        profilePicture: '00_AMVARA_Staff_Yoel_BN.jpg'
    },
    {
        id: 7,
        name: 'Blacky',
        position: 'Watchdog',
        about: ['Full time guardian'],
        gender: 'D',
        profilePicture: '00_AMVARA_Staff_Blacky.jpg'
    },
    
];
